export default __webpack_public_path__ + "static/media/Ballroll_00043.0efb93f9.png";